import React from "react";
import Link from "next/link";
import Image from "next/image";
export default function CaseStudyLink({ link = "#", title, subTitle, image }) {
  return (
    <Link
      href={link}
      className="px-4 w-full group flex flex-col z-0  border-[#707070]/10 overflow-hidden"
    >
      <div className="flex flex-row justify-start gap-4 items-start w-full relative lg:h-[400px] h-[250px]">
        <div className="relative w-full lg:h-[400px] h-[250px] ">
          <Image
            src={image}
            alt="case study"
            className={`w-full h-full object-cover transition-all duration-300 ease rounded-2xl`}
            fill
            sizes="(max-width: 479px) 479px,(max-width: 768px) 768px, (max-width: 1200px) 1200px,(max-width: 1920px) 1920px, 1000px"
          />
          <div className="w-full h-full flex flex-col gap-3 items-center justify-center absolute top-0 left-0 px-4 bg-black/40 rounded-2xl">
            <div
              dangerouslySetInnerHTML={{ __html: title }}
              className="text-white lg:text-[40px] md:text-[32px] text-[22px] leading-tight font-semibold"
            ></div>
            <div
              dangerouslySetInnerHTML={{ __html: subTitle }}
              className="text-white font-body text-center leading-tight lg:max-w-[90%] lg:text-2xl md:text-xl text-[16px]"
            ></div>
          </div>
        </div>
      </div>
    </Link>
  );
}
